function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "spiral-svg",
  d: "M13.517 11.1883C13.517 11.4127 13.7016 11.5944 13.9294 11.5944C14.2145 11.5944 14.4452 11.3672 14.4452 11.0864C14.4452 10.7368 14.1572 10.4518 13.8008 10.4518C13.3549 10.4518 12.9943 10.807 12.9943 11.2461C12.9943 11.794 13.4458 12.2386 14.0021 12.2386C14.6968 12.2386 15.2615 11.6839 15.2615 10.9983C15.2615 10.1407 14.5556 9.44687 13.6862 9.44687C12.6001 9.44687 11.7181 10.3141 11.7181 11.3851C11.7181 12.7232 12.8196 13.808 14.1782 13.808C15.8779 13.808 17.2547 12.4506 17.2547 10.778C17.2547 8.68698 15.5326 6.991 13.4094 6.991C10.7551 6.991 8.60388 9.1096 8.60388 11.7238C8.60388 14.9918 11.2932 17.6404 14.6115 17.6404C18.7587 17.6404 22.1203 14.3297 22.1203 10.2453C22.1203 5.13946 17.9172 1 12.7329 1C6.25283 1 1 6.17329 1 12.5553C1 20.5327 7.56673 27 15.6668 27C25.7923 27 34 18.9166 34 8.94441C34 6.991 33.6208 4.2437 33.0535 2.78576",
  stroke: "black",
  strokeWidth: 0.8,
  strokeMiterlimit: 10
});

function SvgSpiral(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 28,
    viewBox: "0 0 35 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpiral);
export default __webpack_public_path__ + "static/media/Spiral.62f4e5ce.svg";
export { ForwardRef as ReactComponent };